/* eslint-disable */
function initMobileMenu() {
  // Mobi menu
  // $('body .hamburger').on('click', () => {
  //   $('body').toggleClass('mobi-menu-open');
  //   $(this).toggleClass('is-active');
  // });
  let logoSmall = $('#page-header .col-logo .header-logo').clone();
  logoSmall.children('.logo-full').remove();
  const navToggler = $('#page-header .col-navbar .navbar-toggler#menu-open-mobile').clone();
  navToggler.attr('id', 'menu-close-mobile');

  var mmenu = new Mmenu(".navbar-mobile", {
    slidingSubmenus: true,
    theme: "light-contrast",
    offCanvas: {
      // don't use the left or right position
      // css transform will destroy position fixed menu
      position: "left-front"
    },
    navbars: [
      {
        position: "top",
        content: [
          logoSmall[0],
          navToggler[0]
        ]
      }, {
        position: "top",
        content: [
          "prev"
        ]
      }
    ]
  });
  var mmenuApi = mmenu.API;

  document.querySelector('#menu-open-mobile').addEventListener(
    "click", () => {
      mmenuApi.open();
    }
  );
  document.querySelector('#menu-close-mobile').addEventListener(
    "click", () => {
      mmenuApi.close();
    }
  );

  $('.mm-btn.mm-hidden').append('<span class="sr-only">Toggle menu</span>');

  // minimize page header on load and on scroll
  let waiting = false;
  $(window).scroll( function() {
    if (waiting) {
      return;
    }
    waiting = true;
    minimizePageHeader();

    setTimeout(function () {
      waiting = false;
    }, 100);
  });
}

function minimizePageHeader() {
  var ph = $('#page-header');
  var wn = ph.children('.wrapper-navbar');
  var h = ph.height();
  if (h === 0) {
    h = wn.height();
  } else {
    h = h / 2;
  }
  if ($(this).scrollTop() > h) {
    wn.addClass('minimized');
  } else {
    wn.removeClass('minimized');
  }
}

// open submenu in 2nd and 3rd level
$('.megamenu .megamenu-submenu-collapse').each(function() {
  this.addEventListener('show.bs.collapse', event => {
    let thisId = $(event.target).attr('id');
    let triggerButton = $('.megamenu button[data-bs-target="#'+thisId+'"]');
    let megamenuParent = triggerButton.data('bsParent');
    if (typeof megamenuParent !== 'undefined' && $(megamenuParent).find('.collapse.show').length > 0) {
      $(megamenuParent).find('.collapse.show').each(function () {
        bootstrap.Collapse.getInstance(this).hide();
      });
    }
  })
});

const lockedClass = 'tmp-locked';
const mainMenuSubs = $('.navbar-main .menu-lvl-0 > .subs .megamenu');
mainMenuSubs.on('mouseenter mouseleave focus focusin focusout', function (e) {
  const lockedDelay = 400;
  const curLiElm = $(this);
  let openSubmenuClass = 'openSubmenu';
  let body = $('body');
  let navbarWrapper = $('.wrapper-navbar-inner');
  let megamenuWrapper = $('.megamenu.dropdown-menu');

  if (e.type === 'mouseenter') {
    curLiElm.addClass(lockedClass);
  }

  // open submenu
  switch (e.type) {
    case 'focus':
    case 'focusin':
    case 'mouseenter':
      body.addClass(openSubmenuClass);
      let wrapperOffset = navbarWrapper.width() - $('.content-main').width();
      navbarWrapper.css('padding-right', wrapperOffset + 'px')
      megamenuWrapper.css('padding-right', wrapperOffset + 'px')
      break;
    case 'focusout':
    case 'mouseleave':
      let delay = ((curLiElm.hasClass(lockedClass) === true) ? lockedDelay : 0);

      setTimeout(function () {
        body.removeClass(openSubmenuClass);
        navbarWrapper.css('padding-right', '');
        megamenuWrapper.css('padding-right', '');
        curLiElm.removeClass(lockedClass);

        // remove focus on mouse leave
        $(document.activeElement).blur();
      }, delay);
      break;
  }
});
